import React, { useState } from "react";
import { Box, Typography, Divider } from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import Grid2 from "@mui/material/Grid2";
import img1 from "../assets/img/homePage1.webp";
import img2 from "../assets/img/homePage2.webp";
import img3 from "../assets/img/homePage3.webp";
import img4 from "../assets/img/homePage4.webp";
import Testimonials from "../components/Testimonials";
import Carousel from "react-material-ui-carousel";
import Fade from "@mui/material/Fade";

const Home = () => {
  const items = [
    {
      imgLeft: img1,
      imgRight: img2,
      text1:
        "The interiors reflect a refined simplicity, where every design choice contributes to a cohesive, calming atmosphere. The minimalist aesthetic, accented with subtle hues, ensures that no detail overwhelms the senses, allowing the space to breathe and feel expansive.",
      text2:
        "Functionality plays a key role in the layout, with smart storage solutions and an open plan enhancing the flow of the home. This home stands as a testament to modern living, where subtle luxury and practical design coalesce into an effortlessly chic home for today's discerning homeowner.",
    },
    {
      imgLeft: img3,
      imgRight: img4,
      text1:
        "Step into this serene 2-bedroom apartment, where every corner feels like a breath of fresh air. Chic and subtle tones create a serene base bathed in white, creating a spacious and breezy ambiance.",
      text2:
        "Soft shades of blue and pink weave a gentle warmth, while pops of yellow add vibrancy, making the space both relaxing and uplifting. Located in Kanjurmarg, Mumbai, this compact home redefines urban living with its creative approach to design.",
    },
  ];

  const [imageText1, setImageText1] = useState(items[0].text1);
  const [imageText2, setImageText2] = useState(items[0].text2);
  const [fadeIn, setFadeIn] = useState(true);

  const handleCarouselChange = (index) => {
    setFadeIn(false); // Trigger fade out
    setTimeout(() => {
      setImageText1(items[index].text1);
      setImageText2(items[index].text2);
      setFadeIn(true); // Trigger fade in
    }, 1000); // Match this timeout to the `timeout` prop of the Fade component
  };

  return (
    <>
      <Box sx={{ flexGrow: 1, padding: "1rem" }}>
        <Box
          sx={{
            overflow: "hidden",
            maxWidth: "1000px", // Constrain width to keep items together
            margin: "0 auto", // Center content
          }}
        >
          <Box
            component="a"
            href="https://www.instagram.com/alchemycollective.20/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: 1,
              mb: 0.5,
              py: 1,
              textDecoration: "none",
              color: "#555555",
              transition: "all 0.3s ease",
              cursor: "pointer",
              "&:hover": {
                color: "#111111",
              },
            }}
          >
            <Typography
              sx={{
                fontFamily: "Avenir",
                fontSize: "1rem",
                borderBottom: "1px solid transparent",
                "&:hover": {
                  borderBottom: "1px solid #111111",
                },
              }}
            >
              Designs @alchemycollective.20
            </Typography>
            <InstagramIcon />
          </Box>

          <Grid2 container spacing={2} justifyContent="center">
            <Grid2 size={{ xs: 12, md: 12 }} sx={{ maxWidth: "100%" }}>
              <Carousel
                autoPlay={true}
                interval={4000}
                animation="fade"
                indicators={false}
                duration={2000}
                stopAutoPlayOnHover={false}
                navButtonsAlwaysInvisible={true}
                onChange={handleCarouselChange}
              >
                <Box
                  component="img"
                  src={items[0].imgLeft}
                  alt="carousel left"
                  sx={{
                    maxWidth: "100%",
                    width: "100%",
                    height: { xs: "20rem", sm: "30rem", md: "45rem" },
                    objectFit: "contain",
                  }}
                  loading="lazy"
                />
                <Box
                  component="img"
                  src={items[1].imgLeft}
                  alt="carousel left"
                  sx={{
                    maxWidth: "100%",
                    width: "100%",
                    height: { xs: "20rem", sm: "30rem", md: "45rem" },
                    objectFit: "contain",
                  }}
                  loading="lazy"
                />
              </Carousel>
            </Grid2>
          </Grid2>
          <Grid2 container spacing={2} justifyContent="center">
            <Fade in={fadeIn} timeout={1000}>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <Typography sx={{ fontFamily: 'Avenir', color: '#0F0F0F' }}>{imageText1}</Typography>
              </Grid2>
            </Fade>
            <Fade in={fadeIn} timeout={1000}>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <Typography sx={{ fontFamily: 'Avenir', color: '#0F0F0F' }}>{imageText2}</Typography>
              </Grid2>
            </Fade>
          </Grid2>
        </Box>
      </Box>
      <Divider sx={{ maxWidth: "1000px", margin: "2rem auto" }} />
      <Testimonials />
    </>
  );
};

export default Home;
